<template>
  <article class="error">
    <div>
      <strong class="error__title"> Erro ao carregar mais resultados </strong>
      <WParagraph size="large">
        Caso o erro persista entre em contato com nosso time.
      </WParagraph>
    </div>

    <WButton type="button" @click="$emit('tryAgain')">
      Tentar novamente
    </WButton>
  </article>
</template>

<script>
import { WButton, WParagraph } from '@alice-health/wonderland-vue'

export default {
  components: {
    WParagraph,
    WButton
  },
  emits: ['tryAgain']
}
</script>

<style lang="scss" scoped>
.error {
  align-items: center;
  display: flex;
  gap: var(--gl-spacing-06);

  &__title {
    color: var(--gl-color-shades-red-60);
    font-size: var(--gl-font-size-xs);
    font-weight: var(--gl-font-weight-semibold);
  }
}
</style>
